import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    width: '100%'
  },
  button: {
    minWidth: 'unset',
    width: '100%',
    margin: '8px'
  }
});

const BtnGroup = ({ btns }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {btns.map(btn => (
        <Button
          className={classes.button}
          id={`btn-${btn.value}`}
          key={`btn-${btn.value}`}
          color="primary"
          variant="contained"
          onClick={() => btn.callback(btn.value)}
        >
          {btn.text}
        </Button>
      ))}
    </div>
  );
};

export default BtnGroup;
